module.exports = __webpack_public_path__ + "static/media/gallery-5.27cc41c7.jpg";